module.exports = {
	"articleTitle1": "On The Daily: Students 'hype' for $1 Pancheros burritos ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Panchero's",
	"articleLink1": "https://www.michigandaily.com/section/news/daily-students-hype-1-pancheros-burritos",
	"articleLink2": "https://www.michigandaily.com/content/pancheross-burrito-reigns-king",
	"articleSnippet1": "Sep 13, 2016 ... For University of Michigan students who worked up an appetite from start of the \nsecond week of class, Pancheros Mexican Grill on South ...",
	"articleSnippet2": "Mar 25, 2004 ... Some people eat until they are full. I, on the other hand, choose to eat until I hurt. \nThough satisfying, this habit of eating past the point of safety ...",
	"foodRecommendations": [],
	"articleTitle2": "Pancheros's burrito reigns king",
	"address": "1208 S University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.274697,
		"lng": -83.733923
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pancheros.json
// module id = 944
// module chunks = 0